<template>
    <div class='menu'>
        <!-- logo -->
        <div class="home" :class='{active:activeTab == 0}' @click="activeTo(0)">
            <img v-show="activeTab == 0" src='~assets/image/icon-busys-white.png'>
            <img v-show="activeTab != 0" src='~assets/image/icon-busys-green.png'>
        </div>

        <!-- 主菜单 -->
        <div class="main-choice" v-for="(data,index) in main_menu" :key="data.name">
            <div class='main-title' :class="{choice:!getSecondMenu(data).length,active:mainChoice(index)}"  @click="activeTo(index+1)">
                <div class="text">
                    <img class="icon" :src="data.icon | menuIcon(mainChoice(index))">
                    {{ data.text }}
                </div>
                <i v-show="getSecondMenu(data).length" class='el-icon-arrow-right' :class="{active:mainChoice(index) && menu_on}"></i>
                
            </div>
            <!-- 二级菜单 -->
            <div class="second-menu" :class="{active:mainChoice(index) && menu_on}">
                <div class="second-item choice" :class="{active:i == active_sec_index[index]}" v-for="(item,i) in getSecondMenu(data)" :key="item.name" @click="secondTo(index,i)">
                    {{ item.text }}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import frontRouter from "src/config/router-front-config.js"

    export default {
        data(){
            return {
                activeTab:0,    //一级菜单active序号
                menu_on:true,   //允许下拉框出现
                active_sec_index:[],  //二级菜单active数组
            } 
        },
        computed:{
            main_menu(){  //主菜单
                return frontRouter.children.slice(2)
            },
        },

        mounted(){
            this.active_sec_index = this.main_menu.map(item=>{
                return 0;
            });
        },
        methods:{

            mainChoice(index){
                return index == this.activeTab - 1;
            },

            getSecondMenu:(function(){  //构造二级菜单
                const map = new Map();
                return function(data){
                    let list = map.get(data);
                    if(list){
                        return list;
                    }

                    list = data.children || [];
                    list = list.filter(choice=>{
                        return  choice.secondMenu == true; 
                    });
                    map.set(data,list);
                    return list;
                }
            })(),

            activeTo(index){  //解锁menu
                if(index == this.activeTab){
                    this.menu_on = !this.menu_on;
                    return;
                }
                this.menu_on = true;
                this.activeTab = index;
            },
            secondTo(index,i){
                this.active_sec_index.splice(index,1,i);
            },
        },
    }
</script>

<style lang="less" scoped>
    @import '~src/assets/less/var.less';
    .menu{
        width:@front_side_w;
        height:100%;
        float:left;
        color:#fff;
        background:#364760;
    }

    // 头部logo
    .home{
        height:60px;
        box-shadow: 0 1px 2px 0 #1d293b;
        box-sizing: border-box;
        position: relative;
        cursor: pointer;
        transition:0.3s;
        &.active{
            background:@main-c;
        }
        img{
            width: 130px;
            height:39px;
            position: absolute;
            left: 44%;
            top:50%;
            transform: translate(-50%,-50%);
        }
    }

    // 主菜单
    .main-title{
        height:56px;
        line-height: 56px;
        padding-left: 24px;
        cursor: pointer;
        font-size:14px;
        transition:0.3s;
        position: relative;
        &:hover{
            background:#48576a;
        }
        
        .text{
            .icon{
                height: 20px;
                width:20px;
                vertical-align: middle;
                margin-right:15px;
            }

        }

        i{
            transition:0.3s;
            position: absolute;
            top:50%;
            transform:translateY(-50%);
            right:20px;
            &.active{
                transform: translateY(-50%) rotate(90deg);
            }
        }
    }

    // 二级菜单
    .second-menu{
        position: relative;
        overflow: hidden;
        max-height:0;
        transition:0.5s;
        &.active{
            max-height:200px;
        }

        .second-item{
            background:#202e3d;
            padding-left: 60px;
            font-size:12px;
            height: 36px;
            line-height: 36px;
            cursor: pointer;
            transition:0.3s;
           

            &:hover{
                color:@main-c;
            }
        }
        
    }

    // 有active的可能性
    .choice{
        &.active{   //当前激活的菜单
            color:@main-c;
            box-shadow: 2px 0 0 0 @main-c inset;
            background:#48576a;
        }
    }
</style>


// WEBPACK FOOTER //
// demoMenu.vue?556554f0